import { useState, useEffect } from 'react';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Blog = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchBlogPosts();
  }, []);

  const fetchBlogPosts = async () => {
    try {
      const response = await axios.get(`${API}/blog`);
      setBlogPosts(response.data);
    } catch (error) {
      console.error('Error fetching blog posts:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <div>
      <section className="py-24 md:py-32" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-bold mb-6"
              style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              data-testid="blog-heading"
            >
              Resources & Insights
            </h1>
            <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
              Stay updated with the latest market trends, trading tips, and investment strategies
            </p>
          </div>

          {isLoading ? (
            <div className="text-center py-12">
              <p className="text-base" style={{ color: '#475569' }}>
                Loading articles...
              </p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 gap-8">
              {blogPosts.map((post, idx) => (
                <Link
                  to={`/blog/${post.id}`}
                  key={post.id}
                  data-testid={`blog-card-${idx}`}
                  className="card-hover bg-[#FFFFFF] border border-[rgba(10,15,26,0.05)] overflow-hidden block"
                  style={{ textDecoration: 'none' }}
                >
                  <img
                    src={post.image_url}
                    alt={post.title}
                    className="w-full h-56 object-cover"
                  />
                  <div className="p-8">
                    <div className="flex items-center gap-4 mb-4">
                      <span
                        className="text-xs uppercase tracking-[0.2em] font-semibold px-3 py-1"
                        style={{ backgroundColor: '#FFF4E6', color: '#FF5722' }}
                      >
                        {post.category}
                      </span>
                      <div className="flex items-center gap-1 text-xs" style={{ color: '#94A3B8' }}>
                        <Clock size={14} />
                        {post.read_time}
                      </div>
                    </div>
                    <h3
                      className="text-xl sm:text-2xl font-semibold mb-3"
                      style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
                    >
                      {post.title}
                    </h3>
                    <p className="text-base mb-4" style={{ color: '#475569' }}>
                      {post.excerpt}
                    </p>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2 text-sm" style={{ color: '#94A3B8' }}>
                        <Calendar size={14} />
                        {formatDate(post.published_date)}
                      </div>
                      <span className="inline-flex items-center gap-1 text-sm font-medium" style={{ color: '#FF5722' }}>
                        Read More <ArrowRight size={14} />
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="py-24 md:py-32" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24 text-center">
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-semibold mb-6"
            style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
          >
            Ready to Start Trading?
          </h2>
          <p className="text-base mb-8" style={{ color: '#475569' }}>
            Apply your knowledge and open your Demat account today
          </p>
          <Link
            to="/brokerage-plans"
            data-testid="blog-cta-button"
            className="btn-primary"
            style={{
              backgroundColor: '#FF5722',
              color: 'white',
              fontWeight: 600,
              padding: '1rem 2rem',
              textDecoration: 'none',
              display: 'inline-block',
            }}
          >
            Open Free Account
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Blog;